import { render, staticRenderFns } from "./FranchiseeData.vue?vue&type=template&id=25ce44d5"
import script from "./FranchiseeData.vue?vue&type=script&lang=js"
export * from "./FranchiseeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports